"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.logToServer = logToServer;
exports.setUser = void 0;
var _browserInfo = _interopRequireDefault(require("browser-info"));
var _getAppVersion = _interopRequireDefault(require("./getAppVersion"));
var _getSessionId = _interopRequireDefault(require("./getSessionId"));
var _shouldLogFromConsoleWrap = _interopRequireDefault(require("./shouldLogFromConsoleWrap"));
var _toJson = _interopRequireDefault(require("./toJson"));
const version = (0, _getAppVersion.default)();
const sessionId = (0, _getSessionId.default)();
const bannedVariables = ['id_token', 'access_token'];
let language;
let userId;
const setUser = data => {
  var _data$preferences, _data$user;
  language = data === null || data === void 0 ? void 0 : (_data$preferences = data.preferences) === null || _data$preferences === void 0 ? void 0 : _data$preferences.userLanguage;
  userId = data === null || data === void 0 ? void 0 : (_data$user = data.user) === null || _data$user === void 0 ? void 0 : _data$user.userId;
};
exports.setUser = setUser;
function logToServer(level, message, data, fromConsoleWrap) {
  let sourceContext = 'Component';
  /* istanbul ignore next */
  if (fromConsoleWrap) sourceContext = 'console';

  // remove all necessary messages
  /* istanbul ignore next */
  if (fromConsoleWrap && !(0, _shouldLogFromConsoleWrap.default)(message)) return;
  let safeData;
  try {
    safeData = (0, _toJson.default)(data);
  } catch (e) {
    /* istanbul ignore next */
    // eslint-disable-next-line no-console
    if (!fromConsoleWrap) console.error('Could not convert log data to a json object', e);
  }
  let {
    href
  } = window.location;

  // remove any banned variables from the url such as access_token etc
  bannedVariables.forEach(variable => {
    const regex = new RegExp("".concat(variable, "=[^&]*&"), 'g');
    href = href.replace(regex, '');
  });
  const logObj = {
    url: href,
    message,
    language,
    userGuid: userId,
    sourceContext,
    component: 'web',
    version,
    device: {
      agent: navigator.userAgent,
      ...(0, _browserInfo.default)(),
      screenResolution: "".concat(window.screen.width, "x").concat(window.screen.height)
    },
    additionalData: safeData,
    sessionId
  };
  try {
    const {
      logger
    } = window.icisHeader;
    logger[level](logObj);
  } catch (e) {
    /* istanbul ignore next */
    if (!fromConsoleWrap) {
      /* istanbul ignore next */
      // eslint-disable-next-line no-console
      console.error('Could not send the log to the server, something is very wrong', window, level, e);
    }
  }
  /* istanbul ignore next */
  if (fromConsoleWrap) return;
}
const log = function () {
  for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
    props[_key] = arguments[_key];
  }
  return logToServer('log', ...props);
};
const info = function () {
  for (var _len2 = arguments.length, props = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    props[_key2] = arguments[_key2];
  }
  return logToServer('info', ...props);
};
const debug = function () {
  for (var _len3 = arguments.length, props = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    props[_key3] = arguments[_key3];
  }
  return logToServer('debug', ...props);
};
const warn = function () {
  for (var _len4 = arguments.length, props = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    props[_key4] = arguments[_key4];
  }
  return logToServer('warn', ...props);
};
const error = function () {
  for (var _len5 = arguments.length, props = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    props[_key5] = arguments[_key5];
  }
  return logToServer('error', ...props);
};
const fatal = function () {
  for (var _len6 = arguments.length, props = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    props[_key6] = arguments[_key6];
  }
  return logToServer('fatal', ...props);
};
const logger = {
  log,
  info,
  debug,
  warn,
  error,
  fatal
};
var _default = exports.default = logger;